import { useTranslation } from "react-i18next";
import SVGSelector from "../common-components/SVGSelector";
import { getEdgeClass } from "../../utils";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const FuelInformationSection = ({ refresh }) => {
  const { t } = useTranslation();
  const { edge = false } = useSelector((state) => state?.uiConfig) || {};
  const navigate = useNavigate();
  return (
    <div
      className="container 2xl:max-w-[1336px] lg:max-w-[1200px] m-auto px-2 pt-2"
      id="information-footer-section"
    >
      <div className="my-4 max-md:mt-8">
        <div className="gap-4 max-md:flex-col">
          <div className="w-[80%] text-[var(--davy-gray-color)] text-xs space-y-5 max-md:w-full py-10">
            <p>
              {" "}
              <SVGSelector name="i-svg" /> {t("/vehicleDetails.VAT reportable")}
            </p>
            <p>
              <SVGSelector name="ii-svg" /> {" "}
              {t("/.FuelConsumptionInformation2")} :{" "}
              <a
                href="https://www.dat.de/co2/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.dat.de/co2/.
              </a>
            </p>
            <p>{t("/vehicleDetails.Legal notice")}</p>
            <p>
              {t(
                "/vehicleDetails.All information is non-binding. Errors and omissions excepted.",
              )}
            </p>
            <button
              className={`p-2 py-1 font-light tracking-[-0.5px] flex items-center gap-2 bg-[var(--primary-color-single)] text-sm text-white border  hover-text-primary-color ${getEdgeClass(edge, "rounded-[4px]")} hover:stroke-white`}
              type="button"
              onClick={() => {
                navigate(`?view=version-info`);
                if (refresh) {
                  window.location.reload();
                }
              }}
            >
              Versionsinfo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FuelInformationSection;
